module.exports = __webpack_public_path__ + "img/形状 1125@2x.8e193959.png";